import type { Permissions } from '@/Interfaces/Data';
import type { DotNestedKeys } from '@/_types/utils';

export const DELIVERY_LIST_PERMISSION_KEYS: DotNestedKeys<Permissions>[] = [
  'delivery.associateDelivery',
  'delivery.cancelDelivery',
  'delivery.deliveryStatus',
  'delivery.reopenDelivery',
];
